const contentTypeJson = "application/json";
const apiGroup = "/api/group";
const apiProject = "/api/project";

// Get a Group.
const getGroup = function (groupId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiGroup + "/" + groupId, requestOptions)
    .then(handleResponse)
    .then((group) => {
      return group;
    });
};

// Update a Group.
const updateGroup = function (groupId, group) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
    body: JSON.stringify(group),
  };

  return fetch(apiGroup + "/" + groupId, requestOptions)
    .then(handleResponse)
    .then((groupResp) => {
      return groupResp;
    });
};

/**
 * Create a project.
 *
 * Project object:
 *  "description": "string"
 *  "enabled": true
 *  "name": "string"
 */
const createProject = function (groupId, project) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
    body: JSON.stringify(project),
  };

  return fetch(apiGroup + "/" + groupId + "/project", requestOptions)
    .then(handleResponse)
    .then((projectResp) => {
      return projectResp;
    });
};

/**
 * Get this group's projects
 */
const getProjects = function (groupId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiGroup + "/" + groupId + "/project", requestOptions)
    .then(handleResponse)
    .then((projects) => {
      return projects;
    });
};

/**
 * Get groups the user has access to
 */
const getGroups = function () {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiGroup, requestOptions)
    .then(handleResponse)
    .then((groups) => {
      return groups;
    });
};

/**
 * Get projects URL
 */
const getProjectUrl = function (projectId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiProject + "/" + projectId + "/url", requestOptions).then(
    (resp) => {
      return resp.text().then((url) => {
        return url;
      });
    }
  );
};

/**
 * Invite to group
 */
const createInvitation = function (groupId, emailAddress, owner = false) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
    body: JSON.stringify({ emailAddress, owner }),
  };

  return fetch(apiGroup + "/" + groupId + "/invitation", requestOptions).then(
    (status) => {
      return status;
    }
  );
};

/**
 * List group Invitations
 */
const getInvitations = function (groupId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiGroup + "/" + groupId + "/invitation", requestOptions)
    .then(handleResponse)
    .then((invitations) => {
      return invitations;
    });
};

/**
 * Invite to group
 */
const acceptInvitation = function (token) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiGroup + "/invitation/" + token, requestOptions)
    .then(handleResponse)
    .then((invitation) => {
      return invitation;
    });
};

/**
 * group Meter
 */
const getMeter = function (groupId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiGroup + "/" + groupId + "/meter", requestOptions)
    .then(handleResponse)
    .then((meter) => {
      return meter;
    });
};

/**
 * group meterEvents
 */
const meterEvents = function (groupId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiGroup + "/" + groupId + "/meterEvents", requestOptions)
    .then(handleResponse)
    .then((events) => {
      return events;
    });
};

/**
 * group ownMeterEvents
 */
const ownMeterEvents = function (groupId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiGroup + "/" + groupId + "/meter/events", requestOptions)
    .then(handleResponse)
    .then((events) => {
      return events;
    });
};

/**
 * group Members
 */
const getMembers = function (groupId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiGroup + "/" + groupId + "/member", requestOptions)
    .then(handleResponse)
    .then((members) => {
      return members;
    });
};

/**
 * Modify member ownership
 */
const modMember = function (groupId, appUserId, owner) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
    body: JSON.stringify({ owner }),
  };

  return fetch(apiGroup + "/" + groupId + "/owner/" + appUserId, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
};

// Delete a group owner
const deleteOwner = function (groupId, appUserId) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiGroup + "/" + groupId + "/owner/" + appUserId, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return response;
    });
};

const whitelistAccess = function (groupId) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiGroup + "/" + groupId + "/whitelistAccess", requestOptions)
    .then(handleResponse)
    .then((resp) => {
      return resp;
    });
};

const handleResponse = function (resp) {
  return resp.text().then((text) => {
    let data;
    try {
      data = text && JSON.parse(text);
    } catch (e) {
      data = e;
    }
    if (!resp.ok) {
      if (resp.status === 503) {
        localStorage.removeItem("user");
        location.replace("/maintenance");
      }

      if (resp.status === 403) {
        localStorage.removeItem("user");
        location.replace("/login?dest=403");
      }

      if (resp.status === 401) {
        location.reload(true);
      }

      if (resp.status === 404) {
        location.replace("/error?err=404");
      }

      if (resp.status === 400 && data.message === "User does not have permission for group") {
        location.replace("/error?err=403");
      }

      const err = (data && data.message) || resp.statusText;
      return Promise.reject(err);
    }

    return data;
  });
};

export const groupService = {
  getGroup,
  updateGroup,
  createProject,
  getProjects,
  getGroups,
  createInvitation,
  acceptInvitation,
  getInvitations,
  getMeter,
  meterEvents,
  ownMeterEvents,
  getMembers,
  modMember,
  deleteOwner,
  getProjectUrl,
  whitelistAccess,
};
